import { useState, useEffect, useRef } from 'react';
import {
  Form,
  Select,
  Row,
  Col,
  Divider,
  Tag,
  theme,
  Typography,
  AutoComplete,
  Input,
  Tooltip,
  Spin
} from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { selectCatalogByName } from 'selectors/catalogos.selectors';
import useScreenSize from 'utils/useScreenSize';
import { PlusOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { PERSONALIZADO, GENERICO, CONJUNTO, DIRECTO } from 'constants/tipoBeneficio';
// import { TIPO_BENEFICIO, BENEFICIADOS } from 'constants/nombresCatalogos';
import { TIPO_BENEFICIO } from 'constants/nombresCatalogos';
import { groupObjectsByProperty } from 'utils/groupObjectsByProperty';
import { removeDuplicatesByProperty } from 'utils/removeDuplicatedByProperty';
import { AddButton } from 'components';
import { generateId } from 'utils/idGenerator';
import PropTypes from 'prop-types';
import './Beneficiados.scss';
import * as fieldMsgs from 'constants/formFieldsMessages';
import { getCatBeneficiados } from 'actions/catBeneficiados.actions';
import {
  CAMPANIA_ASO,
  PRECAMPANIA_ASO,
  APOYO_CIUDADANO_ASO,
  INTERCAMPANIA_ASO
} from 'constants/tipoAsociaciones';

const { Text } = Typography;

const getBeneficiadosPorAsociacionId = (listaAsociaciones, beneficiadoId) => {
  const asociacion = listaAsociaciones?.find((b) => b.idTipoAsociacion === beneficiadoId);
  return asociacion?.beneficiarios || [];
};

const getTiposAsociacionPorProcesoEspecifico = (listaBeneficiadosCompleta, procesoEspecificoId) => {
  let asociaciones = [];

  if (!Array.isArray(listaBeneficiadosCompleta) || listaBeneficiadosCompleta.length === 0) {
    switch (procesoEspecificoId) {
      case 2:
        asociaciones = CAMPANIA_ASO;
        break;
      case 1:
        asociaciones = PRECAMPANIA_ASO;
        break;
      case 3:
        asociaciones = APOYO_CIUDADANO_ASO;
        break;
      default:
        asociaciones = INTERCAMPANIA_ASO;
        break;
    }
    const aso = groupObjectsByProperty(asociaciones, 'tipoAsociacion');
    return Object.keys(aso).map((tipoAsociacion) => {
      return {
        tipoAsociacion,
        idTipoAsociacion: aso[tipoAsociacion][0].idTipoAsociacion,
        beneficiarios: aso[tipoAsociacion]
      };
    });
  }
  // const listaBeneficiados = listaBeneficiadosCompleta.filter(
  //   (beneficiado) => beneficiado.idProcesoSIMAC === procesoEspecificoId
  // );
  const listaBeneficiados = listaBeneficiadosCompleta;
  // const asociaciones = groupObjectsByProperty(listaBeneficiados, 'tipoAsociacion');
  asociaciones = groupObjectsByProperty(listaBeneficiados, 'tipoAsociacion');
  return Object.keys(asociaciones).map((tipoAsociacion) => {
    return {
      tipoAsociacion,
      idTipoAsociacion: asociaciones[tipoAsociacion][0].idTipoAsociacion,
      beneficiarios: asociaciones[tipoAsociacion]
    };
  });
};

// eslint-disable-next-line no-unused-vars
const getCargosPorProcesoEspecifico = (listaBeneficiadosCompleta) => {
  if (!listaBeneficiadosCompleta) {
    return [];
  }
  // const listaBeneficiados = listaBeneficiadosCompleta.filter(
  //   (beneficiado) => beneficiado.idProcesoSIMAC === procesoEspecificoId
  // );
  const listaBeneficiados = listaBeneficiadosCompleta;
  const cargos = groupObjectsByProperty(listaBeneficiados, 'cargo');
  return Object.keys(cargos).map((cargo) => {
    return {
      cargo,
      idCargo: generateId()
    };
  });
};

const Beneficiados = ({ form, tipoBeneficioInicial, renderBeneficiados, actionType }) => {
  const { token } = theme.useToken();
  const dispatch = useDispatch();
  const [tipoBeneficioSelecionado, setTipoBeneficioSeleccionado] = useState();
  const [renderBeneficiadosEdit, setRenderBeneficiadosEdit] = useState();
  const tipoBeneficios = useSelector(selectCatalogByName(TIPO_BENEFICIO));
  // const beneficiadosList = useSelector(selectCatalogByName(BENEFICIADOS));
  const [beneficiadosList, setBeneficiadosList] = useState([]);
  const [listaBeneficiados, setListaBeneficiados] = useState([]);
  const [listTipoAsociacion, setListTipoAsociacion] = useState([]);
  const [listSujetosObligados, setListSujetosObligados] = useState([]);
  const [listCargos, setListCargos] = useState([]);
  const [tags, setTags] = useState([]);
  const [infoBeneficiados, setInfoBeneficiados] = useState([]);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputSujetoObligadoVisible, setInputSujetoObligadoVisible] = useState(false);
  const [inputSujetoObligadoGenConjVisible, setInputSujetoObligadoGenConjVisible] = useState(false);
  const [inputCargoVisible, setInputCargoVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);
  const inputRefSO = useRef(null);
  const inputRefSOGC = useRef(null);

  // Obtenemos el tamaño del navegador
  const windowSize = useScreenSize();
  // Lo asignamos para validar el tamaño maximo del tag y visualizar el toolTip
  const lengthMaxTag = windowSize.width < 1200 ? 15 : 25;

  const [loading, setLoading] = useState(false);

  // Método para cargar los tipos de asociación dependiendo del proceso específico
  const getTiposAsociacion = () => {
    const { idProcesoEspecifico } = form.getFieldsValue(['idProcesoEspecifico']);
    const tiposAsociacionPorProcesoEspecifico = getTiposAsociacionPorProcesoEspecifico(
      listaBeneficiados,
      idProcesoEspecifico
    );

    if (tiposAsociacionPorProcesoEspecifico.length === 0) {
      let asociaciones = [];
      switch (idProcesoEspecifico) {
        case 1:
          asociaciones = CAMPANIA_ASO;
          break;
        case 2:
          asociaciones = PRECAMPANIA_ASO;
          break;
        case 3:
          asociaciones = APOYO_CIUDADANO_ASO;
          break;
        default:
          asociaciones = INTERCAMPANIA_ASO;
          break;
      }
      const tiposAsociacionNuevo = asociaciones.map((tipoAsociacion) =>
        Object.defineProperty(
          tipoAsociacion,
          'value',
          Object.getOwnPropertyDescriptor(tipoAsociacion, 'tipoAsociacion')
        )
      );
      setListTipoAsociacion(tiposAsociacionNuevo);
    }
    setListTipoAsociacion(tiposAsociacionPorProcesoEspecifico);
  };

  const loadBeneficiados = async () => {
    try {
      setListaBeneficiados([]);
      if (
        form.getFieldValue('idProcesoGral') &&
        form.getFieldValue('idEstado') &&
        form.getFieldValue('idProcesoEspecifico') &&
        form.getFieldValue('idAmbito') &&
        form.getFieldValue('tipo_beneficio')
      ) {
        const params = {
          idProceso: form.getFieldValue('idProcesoGral'),
          idEstado: form.getFieldValue('idEstado'),
          procesoEspecifico: form.getFieldValue('idProcesoEspecifico'),
          idAmbito: form.getFieldValue('idAmbito'),
          idTipoBeneficiado: form.getFieldValue('tipo_beneficio')
          // idTipoAso: form.getFieldValue('tipoAsociacion')
        };
        const { success: scsCatsBeneficiado, response: respCatsBeneficiado } = await dispatch(
          getCatBeneficiados(params, false)
        );
        // console.log('respCatsBeneficiado', respCatsBeneficiado);

        if (scsCatsBeneficiado && respCatsBeneficiado) {
          setBeneficiadosList(respCatsBeneficiado?.data);
          setListaBeneficiados(respCatsBeneficiado?.data);
          // getTiposAsociacion();
        }
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  // Método para agregar el sujeto obligado de forma manual
  const showInputSujetoObligado = (beneficiado) => {
    const updatedBeneficiado = {
      ...beneficiado,
      flag: 'so'
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    const indexToUpdated = updatedBeneficiadosList.findIndex(
      (b) =>
        b.nombreBeneficiado === updatedBeneficiado.nombreBeneficiado &&
        b.idContabilidad === updatedBeneficiado.idContabilidad
    );
    updatedBeneficiadosList[indexToUpdated] = updatedBeneficiado;
    setInfoBeneficiados(updatedBeneficiadosList);
    setInputSujetoObligadoVisible(true);
  };

  // Método para agregar el sujeto obligado de forma manual en beneficiados genericos y conjunto
  const showInputSujetoObligadoGenericoConjunto = (beneficiado, idx) => {
    const updatedBeneficiado = {
      ...beneficiado,
      flag: 'so'
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    updatedBeneficiadosList[idx] = updatedBeneficiado;
    setInfoBeneficiados(updatedBeneficiadosList);
    setInputSujetoObligadoGenConjVisible(true);
  };

  // Método para agregar un cargo de forma manual
  const showInputCargo = (beneficiado, idx) => {
    const updatedBeneficiado = {
      ...beneficiado,
      flag: 'car'
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    updatedBeneficiadosList[idx] = updatedBeneficiado;
    setInfoBeneficiados(updatedBeneficiadosList);
    setInputCargoVisible(true);
  };

  // Método para obtener el catalogo de sujetos obligados
  // depenediendo del tipo de asociación seleccionada en el select
  const getSujetosObligados = (tipoAsociacionId, nombreAsociacion, infoBene) => {
    if (infoBene !== undefined) {
      const updatedBeneficiado = {
        ...infoBene,
        tipoAsociacion: nombreAsociacion.label,
        idTipoAsociacion: tipoAsociacionId
      };
      const updatedBeneficiadosList = [...infoBeneficiados];
      const indexToUpdated = updatedBeneficiadosList.findIndex(
        (b) =>
          b.nombreBeneficiado === updatedBeneficiado.nombreBeneficiado &&
          b.idContabilidad === updatedBeneficiado.idContabilidad
      );
      updatedBeneficiadosList[indexToUpdated] = updatedBeneficiado;
      form.setFieldsValue({
        beneficiados: updatedBeneficiadosList
      });
      setInfoBeneficiados(updatedBeneficiadosList);
    }

    const { idProcesoEspecifico } = form.getFieldsValue(['idProcesoEspecifico']);

    const tiposAsociacionPorProcesoEspecifico = getTiposAsociacionPorProcesoEspecifico(
      listaBeneficiados,
      idProcesoEspecifico
    );
    const { idEstado } = form.getFieldsValue(['idEstado']);

    if (tipoAsociacionId !== 0) {
      const beneficiadosPorAsociacion = getBeneficiadosPorAsociacionId(
        tiposAsociacionPorProcesoEspecifico,
        tipoAsociacionId
      );
      const beneficiadosPorEntidad = beneficiadosPorAsociacion?.filter(
        (beneficiado) => beneficiado.idEstado === idEstado
      );
      const sujetosObligados = removeDuplicatesByProperty(
        beneficiadosPorEntidad.map((beneficiado) => ({
          sujetoObligado: beneficiado.sujetoObligado,
          idSujetoObligado: beneficiado.idSujetoObligado
        })),
        'idSujetoObligado'
      );
      const sujetosObligadosNuevo = sujetosObligados.map((so) =>
        Object.defineProperty(so, 'value', Object.getOwnPropertyDescriptor(so, 'sujetoObligado'))
      );
      setListSujetosObligados(sujetosObligadosNuevo);
    }
  };

  // Método para obtener los cargos dependiendo del proceso específico
  const getCargos = () => {
    const { idProcesoEspecifico } = form.getFieldsValue(['idProcesoEspecifico']);
    const cargosPorProcesoEspecifico = getCargosPorProcesoEspecifico(
      listaBeneficiados,
      idProcesoEspecifico
    );
    const cargosPorProcesoEspecificoNuevo = cargosPorProcesoEspecifico.map((cargo) =>
      Object.defineProperty(cargo, 'value', Object.getOwnPropertyDescriptor(cargo, 'cargo'))
    );
    setListCargos(cargosPorProcesoEspecificoNuevo);
  };

  // Método que se ejecuta dentro del hook para cargar
  // beneficiados al momento de editar un monitoreo
  const handleTagInBeneficiados = () => {
    const { beneficiados } = form.getFieldValue();
    if (tags.length !== 0 && infoBeneficiados.length !== 0) {
      setTags([]);
      setInfoBeneficiados([]);
    }
    const nameTags = beneficiados.map((beneficiado) => {
      if (beneficiado?.nombreBeneficiado !== undefined) {
        return beneficiado.nombreBeneficiado;
      }
      return '';
    });

    if (
      beneficiados.length > 0 &&
      listaBeneficiados !== null &&
      listaBeneficiados !== undefined &&
      listaBeneficiados.length > 0
    ) {
      const beneficiadosAgregados = new Set(
        beneficiados.map((beneficiado) => beneficiado.nombreBeneficiado)
      );
      const beneficiadosRestantes = listaBeneficiados.filter(
        (beneficiado) => !beneficiadosAgregados.has(beneficiado.nombreBeneficiado)
      );
      setListaBeneficiados(beneficiadosRestantes);
    }

    setTags(nameTags);
    setInfoBeneficiados(beneficiados);
  };

  // Método que se ejecuta dentro del hook para cargar
  // beneficiados genericos y conjunto al momento de editar un monitoreo
  const handleTagInBeneficiadosGenericosConjunto = () => {
    const { beneficiados } = form.getFieldValue();
    if (tags.length !== 0 && infoBeneficiados.length !== 0) {
      setTags([]);
      setInfoBeneficiados([]);
    }
    let nameTags = [];
    const beneficiadosCopy = beneficiados.filter((b) => b !== undefined);
    if (beneficiadosCopy && Array.isArray(beneficiadosCopy)) {
      nameTags = beneficiadosCopy.map((beneficiado) => {
        return beneficiado.tipoAsociacion;
      });
    }

    setTags(nameTags);
    setInfoBeneficiados(beneficiadosCopy);
  };

  // Método para remover nombres de beneficiadados que se encuantran en el array de tags
  const handleCloseTag = (removedTag) => {
    const newTags = tags.filter((tag) => tag !== removedTag);
    if (infoBeneficiados.length > 0) {
      const newInfoBeneficiados = infoBeneficiados.filter(
        // (infoBen) => `${infoBen.nombreBeneficiado} ${infoBen.idContabilidad}` !== removedTag
        (infoBen) => infoBen.nombreBeneficiado !== removedTag
      );
      form.setFieldsValue({
        beneficiados: newInfoBeneficiados
      });
      setInfoBeneficiados(newInfoBeneficiados);
    }
    if (
      removedTag !== undefined &&
      beneficiadosList !== undefined &&
      beneficiadosList?.length > 0
    ) {
      const beneficiadoRemoved = beneficiadosList.find(
        (beneficiado) =>
          // `${beneficiado.nombreBeneficiado} ${beneficiado.idContabilidad}` === removedTag
          beneficiado.nombreBeneficiado === removedTag
      );
      if (beneficiadoRemoved) {
        const updatedListaBeneficiado = [...listaBeneficiados];
        updatedListaBeneficiado.push(beneficiadoRemoved);
        setListaBeneficiados(updatedListaBeneficiado);
      }
    }
    setTags(newTags);
  };

  const handleCloseTagGenericoConjunto = (idx) => {
    const newTags = tags.toSpliced(idx, 1);
    if (infoBeneficiados.length > 0) {
      const newInfoBeneficiados = infoBeneficiados.toSpliced(idx, 1);
      form.setFieldsValue({
        beneficiados: newInfoBeneficiados
      });
      setInfoBeneficiados(newInfoBeneficiados);
    }
    setTags(newTags);
  };

  // Método para remover el sujeto obligado que se ingreso de forma manual
  // se ejecuta en el tag correspondiente (Tag de sujeto obligado)
  const handleCloseTagSujetoObligado = (removeSujetoObligado) => {
    const updatedBeneficiado = {
      ...removeSujetoObligado,
      sujetoObligado: ''
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    const indexToUpdated = updatedBeneficiadosList.findIndex(
      (b) =>
        b.nombreBeneficiado === updatedBeneficiado.nombreBeneficiado &&
        b.idContabilidad === updatedBeneficiado.idContabilidad
    );
    updatedBeneficiadosList[indexToUpdated] = updatedBeneficiado;
    setInfoBeneficiados(updatedBeneficiadosList);
  };

  // Método para remover el sujeto obligado que se ingreso de forma manual
  // se ejecuta en el tag correspondiente (Tag de sujeto obligado)
  const handleCloseTagSujetoObligadoGenericoConjunto = (removeSujetoObligado, idx) => {
    getSujetosObligados(removeSujetoObligado.idTipoAsociacion, removeSujetoObligado.tipoAsociacion);
    const updatedBeneficiado = {
      ...removeSujetoObligado,
      sujetoObligado: '',
      idSujetoObligado: 0
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    updatedBeneficiadosList[idx] = updatedBeneficiado;
    form.setFieldsValue({
      beneficiados: updatedBeneficiadosList
    });
    setInfoBeneficiados(updatedBeneficiadosList);
  };

  // Método para remover el cargo que se ingreso de forma manual
  // se ejecuta en tag correspondiente (Tag de cargo)
  const handleCloseTagCargo = (removedCargo, idx) => {
    const updatedBeneficiado = {
      ...removedCargo,
      cargo: ''
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    updatedBeneficiadosList[idx] = updatedBeneficiado;
    form.setFieldsValue({
      beneficiados: updatedBeneficiadosList
    });
    setInfoBeneficiados(updatedBeneficiadosList);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    setInputCargoVisible(true);
  };

  // Metódo que se ejecuta cuando se selecciona a un beneficiado directo
  // que se muestraen la lista desplegable del autocomplete
  const handleInputSelectConfirmBenDirecto = (e, beneficiadoSelect) => {
    const updatedBeneficiado = {
      ...beneficiadoSelect,
      sujetoObligadoId: beneficiadoSelect.idSujetoObligado,
      beneficiado: beneficiadoSelect.idContabilidad
    };

    if (e !== '' && tags[0] !== '' && tags.length === 0) {
      setTags([...tags, beneficiadoSelect.nombreBeneficiado]);
    }

    if (e !== '' && tags[0] === '') {
      setTags([e]);
    }

    if (e !== '' && infoBeneficiados[0] !== undefined && infoBeneficiados.length === 0) {
      form.setFieldsValue({
        beneficiados: [...infoBeneficiados, updatedBeneficiado]
      });
      setInfoBeneficiados([...infoBeneficiados, updatedBeneficiado]);
    }

    if (e !== '' && infoBeneficiados[0] === undefined) {
      form.setFieldsValue({
        beneficiados: [updatedBeneficiado]
      });
      setInfoBeneficiados([updatedBeneficiado]);
    }
    setInputVisible(false);
    setInputValue('');
  };

  // Metódo que se ejecuta cuando se selecciona a un beneficiado personalizado
  // que se muestraen la lista desplegable del autocomplete
  const handleInputSelectConfirmBenPersonalizado = (e, beneficiadoSelect) => {
    const updatedBeneficiado = {
      ...beneficiadoSelect,
      sujetoObligadoId: beneficiadoSelect.idSujetoObligado,
      beneficiado: beneficiadoSelect.idContabilidad
    };

    if (e !== '' && tags[0] !== '') {
      // && tags.indexOf(beneficiadoSelect.nombreBeneficiado) === -1
      // setTags([...tags, e]);
      setTags([...tags, beneficiadoSelect.nombreBeneficiado]);
    }

    if (e !== '' && tags[0] === '') {
      setTags([e]);
    }

    if (
      e !== '' &&
      infoBeneficiados[0] !== undefined &&
      /* infoBeneficiados
        ?.map((b) => b.nombreBeneficiado||b.idContabilidad)
        .indexOf(beneficiadoSelect.nombreBeneficiado||beneficiadoSelect.idContabilidad) === -1 */
      infoBeneficiados?.map((b) => b.idContabilidad).indexOf(e) === -1
    ) {
      form.setFieldsValue({
        beneficiados: [...infoBeneficiados, updatedBeneficiado]
      });
      setInfoBeneficiados([...infoBeneficiados, updatedBeneficiado]);
    }

    if (e !== '' && infoBeneficiados[0] === undefined) {
      form.setFieldsValue({
        beneficiados: [updatedBeneficiado]
      });
      setInfoBeneficiados([updatedBeneficiado]);
    }

    if (beneficiadoSelect.nombreBeneficiado !== undefined) {
      const nuevaListaBeneficiados = listaBeneficiados.filter(
        (beneficiado) =>
          beneficiado.nombreBeneficiado ||
          beneficiado.idContabilidad !== beneficiadoSelect.nombreBeneficiado ||
          beneficiadoSelect.idContabilidad
      );
      setListaBeneficiados(nuevaListaBeneficiados || []);
    }
    setInputVisible(false);
    setInputValue('');
  };

  // Metódo que se ejecuta cuando se selecciona a un beneficiado generico
  // mostrado en la lista de tipo de asociación
  const handleInputSelectConfirmBenGenerico = (e, tipoAsociacionSelecionada) => {
    let dataBeneficiado = {};
    if (e) {
      dataBeneficiado = {
        tipoAsociacion: tipoAsociacionSelecionada.label,
        idTipoAsociacion: e,
        sujetoObligado: '',
        idSujetoObligado: 0,
        cargo: ''
      };
      setTags([...tags, tipoAsociacionSelecionada.label]);
      form.setFieldsValue({
        beneficiados: [...infoBeneficiados, dataBeneficiado]
      });
      setInfoBeneficiados([...infoBeneficiados, dataBeneficiado]);
    }
  };

  // Metódo que se ejecuta cuando se selecciona un sujeto obligado
  // que se encuentra en la lista desplegable del autocomplete
  const handleInputSelectConfirmSujetoObligadoBeneficiado = (e, option, infoBene) => {
    const updatedBeneficiado = {
      ...infoBene,
      sujetoObligado: e,
      idSujetoObligado: option.idSujetoObligado,
      sujetoObligadoId: option.idSujetoObligado,
      flag: false
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    const indexToUpdated = updatedBeneficiadosList.findIndex(
      (b) =>
        b.nombreBeneficiado === updatedBeneficiado.nombreBeneficiado &&
        b.idContabilidad === updatedBeneficiado.idContabilidad
    );
    updatedBeneficiadosList[indexToUpdated] = updatedBeneficiado;
    form.setFieldsValue({
      beneficiados: updatedBeneficiadosList
    });
    setInfoBeneficiados(updatedBeneficiadosList);
    setInputSujetoObligadoVisible(false);
  };

  // Metódo que se ejecuta cuando se selecciona un sujeto obligado
  // que se encuentra en la lista desplegable del autocomplete
  const handleInputSelectConfirmSujetoObligadoBeneficiadoGenericoConjunto = (
    e,
    option,
    infoBene,
    idx
  ) => {
    const updatedBeneficiado = {
      ...infoBene,
      sujetoObligado: e,
      idSujetoObligado: option.idSujetoObligado,
      sujetoObligadoId: option.idSujetoObligado,
      flag: false
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    updatedBeneficiadosList[idx] = updatedBeneficiado;
    form.setFieldsValue({
      beneficiados: updatedBeneficiadosList
    });
    setInfoBeneficiados(updatedBeneficiadosList);
    setInputSujetoObligadoGenConjVisible(false);
  };

  // Metódo que se ejecuta cuando se selecciona un cargo
  // que se encuentra en la lista desplegable del autocomplete
  const handleInputSelectConfirmCargoBeneficiado = (e, beneficiado, idx) => {
    const updatedBeneficiado = {
      ...beneficiado,
      cargo: e,
      flag: false
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    updatedBeneficiadosList[idx] = updatedBeneficiado;
    form.setFieldsValue({
      beneficiados: updatedBeneficiadosList
    });
    setInfoBeneficiados(updatedBeneficiadosList);
    setInputCargoVisible(false);
  };

  // Método que sirve para agregar beneficiados directos no registrados al momento de oprimir enter
  const handleInputConfirmBenDirecto = (e) => {
    const eventValue = e.target.value.toUpperCase() ?? e;
    const { idProcesoEspecifico, idProcesoGral, idEstado, idDistritoFed, idAmbito } =
      form.getFieldsValue();
    let dataBeneficiado = {};
    if (eventValue !== '' && tags.indexOf(eventValue) === -1 && tags.length === 0) {
      dataBeneficiado = {
        idBeneficiado: 0,
        flag: 'ini',
        nombreBeneficiado: eventValue,
        tipoAsociacion: '',
        idTipoAsociacion: 0,
        sujetoObligado: '',
        idSujetoObligado: 0,
        cargo: '',
        idContabilidad: 0,
        beneficiado: 0,
        idProcesoSIMAC: idProcesoEspecifico,
        idProcesoGral,
        idEstado,
        idDistritoFederal: idDistritoFed,
        idAmbito
      };
      setTags([...tags, eventValue]);
      form.setFieldsValue({
        beneficiados: [...infoBeneficiados, dataBeneficiado]
      });
      setInfoBeneficiados([...infoBeneficiados, dataBeneficiado]);
    }

    setInputVisible(false);
    setInputValue('');
  };

  // Método para agregar beneficiados personalizados no registrados al momento de oprimir enter
  const handleInputConfirmBenPersonalizado = (e) => {
    const eventValue = e.target.value.toUpperCase() ?? e;
    const { idProcesoEspecifico, idProcesoGral, idEstado, idDistritoFed, idAmbito } =
      form.getFieldsValue();
    let dataBeneficiado = {};
    if (eventValue !== '' && tags.indexOf(eventValue) === -1) {
      dataBeneficiado = {
        idBeneficiado: 0,
        flag: 'ini',
        nombreBeneficiado: eventValue,
        tipoAsociacion: '',
        idTipoAsociacion: 0,
        sujetoObligado: '',
        idSujetoObligado: 0,
        cargo: '',
        idContabilidad: 0,
        beneficiado: 0,
        idProcesoSIMAC: idProcesoEspecifico,
        idProcesoGral,
        idEstado,
        idDistritoFederal: idDistritoFed,
        idAmbito
      };
      setTags([...tags, eventValue]);
      form.setFieldsValue({
        beneficiados: [...infoBeneficiados, dataBeneficiado]
      });
      setInfoBeneficiados([...infoBeneficiados, dataBeneficiado]);
    }

    setInputVisible(false);
    setInputValue('');
  };

  // Método para ingresar un sujeto obligado que no se tiene registrado
  const handleInputConfirmSujetoObligadoBeneficiado = (e, beneficiado) => {
    const updatedBeneficiado = {
      ...beneficiado,
      sujetoObligado: e.target.value.toUpperCase(),
      flag: false
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    const indexToUpdated = updatedBeneficiadosList.findIndex(
      (b) =>
        b.nombreBeneficiado === updatedBeneficiado.nombreBeneficiado &&
        b.idContabilidad === updatedBeneficiado.idContabilidad
    );
    updatedBeneficiadosList[indexToUpdated] = updatedBeneficiado;
    form.setFieldsValue({
      beneficiados: updatedBeneficiadosList
    });
    setInfoBeneficiados(updatedBeneficiadosList);
    setInputSujetoObligadoVisible(false);
  };

  // Método para ingresar un sujeto obligado que no se tiene registrado
  const handleInputConfirmSujetoObligadoBeneficiadoGenericoConjunto = (e, beneficiado, idx) => {
    const updatedBeneficiado = {
      ...beneficiado,
      sujetoObligado: e.target.value.toUpperCase(),
      idSujetoObligado: 0,
      sujetoObligadoId: 0,
      flag: false
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    updatedBeneficiadosList[idx] = updatedBeneficiado;
    form.setFieldsValue({
      beneficiados: updatedBeneficiadosList
    });
    setInfoBeneficiados(updatedBeneficiadosList);
    setInputSujetoObligadoGenConjVisible(false);
  };

  // Método para editar el cargo del beneficiado no registrado
  const handleInputConfirmCargoBeneficiado = (e, beneficiado, idx) => {
    const updatedBeneficiado = {
      ...beneficiado,
      cargo: e.target.value.toUpperCase(),
      flag: false
    };
    const updatedBeneficiadosList = [...infoBeneficiados];
    updatedBeneficiadosList[idx] = updatedBeneficiado;
    form.setFieldsValue({
      beneficiados: updatedBeneficiadosList
    });
    setInfoBeneficiados(updatedBeneficiadosList);
    setInputCargoVisible(false);
  };

  // Autocomplete para beneficiado directos para mostrarlas opciones disponibles registradas en la base de datos
  // y filtradas mediante las palabras ingresadas en el input
  const inputAutocompleteBeneficiadoDirecto = (
    beneficiadosNuevo,
    beneficiadosPorProcesoEspecifico,
    idx
  ) => {
    const nombreBeneficiado = (
      <AutoComplete
        className="autocomplete"
        options={beneficiadosNuevo}
        // eslint-disable-next-line no-shadow
        filterOption={(inputValue, option) =>
          option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        }
        onSelect={handleInputSelectConfirmBenDirecto}>
        <Input
          key={idx}
          className="input-autocomplete"
          ref={inputRef}
          placeholder="Seleccione Beneficiado"
          value={inputValue}
          onChange={handleInputChange}
          onBlur={(e) => handleInputConfirmBenDirecto(e, beneficiadosPorProcesoEspecifico)}
          onPressEnter={(e) => handleInputConfirmBenDirecto(e, beneficiadosPorProcesoEspecifico)}
        />
      </AutoComplete>
    );
    return (
      <span key={idx} className="tag-container">
        {nombreBeneficiado}
      </span>
    );
  };

  // Autocomplete para beneficiado personalizados para mostrar las opciones disponibles registradas en la base de datos
  // y filtradas mediante las palabras ingresadas en el input
  const inputAutocompleteBeneficiadoPersonalizado = (
    beneficiadosNuevo,
    beneficiadosPorProcesoEspecifico,
    idx
  ) => {
    const nombreBeneficiado = (
      <AutoComplete
        className="autocomplete"
        options={beneficiadosNuevo}
        // eslint-disable-next-line no-shadow
        filterOption={(inputValue, option) =>
          // option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
        }
        onSelect={handleInputSelectConfirmBenPersonalizado}>
        <Input
          key={idx}
          className="input-autocomplete"
          placeholder="Seleccione Beneficiado"
          value={inputValue}
          onChange={handleInputChange}
          onBlur={(e) => handleInputConfirmBenPersonalizado(e, beneficiadosPorProcesoEspecifico)}
          onPressEnter={(e) =>
            handleInputConfirmBenPersonalizado(e, beneficiadosPorProcesoEspecifico)
          }
        />
      </AutoComplete>
    );
    return (
      <span key={idx} className="tag-container">
        {nombreBeneficiado}
      </span>
    );
  };

  // Select tipo de asociación mostrado en beneficiados generico y conjunto
  const selectBenGenericoConjunto = (tiposAsociacion, idx) => {
    const tipoAsociacionMostradas = (
      <Select
        key={idx}
        className="autocomplete"
        options={tiposAsociacion.map((tipoAsociacion) => ({
          label: tipoAsociacion.tipoAsociacion,
          value: tipoAsociacion.idTipoAsociacion
        }))}
        placeholder="Selecciona"
        onSelect={handleInputSelectConfirmBenGenerico}
        onChange={(value, label) => getSujetosObligados(value, label)}
      />
    );
    return (
      <span key={idx} className="tag-container">
        {tipoAsociacionMostradas}
      </span>
    );
  };

  // Método que muestra el tag con el nombre del beneficiado directo una vez seleccionado
  const forNomBeneficiadoDirecto = (tag, idx) => {
    const isLongTag = tag[idx] !== undefined && tag[idx] ? tag[idx].length > lengthMaxTag : false;
    const tagElem = (
      <Tag
        closeIcon={<CloseCircleOutlined />}
        className="tag"
        closable
        onClose={(e) => {
          e.preventDefault();
          handleCloseTag(tag[idx]);
        }}>
        <span>{isLongTag ? `${tag[idx].slice(0, lengthMaxTag)}...` : tag[idx]}</span>
      </Tag>
    );
    return isLongTag ? (
      <Tooltip title={tag[idx]} key={idx}>
        {tag?.length !== 0 ? tagElem : ''}
      </Tooltip>
    ) : (
      <span>{tag?.length !== 0 ? tagElem : ''}</span>
    );
  };

  // Método que muestra el tag del beneficiado personalizado una vez seleccionado
  const forNomBeneficiadoPersonalizado = (tag, idx) => {
    const isLongTag = tag && tag[idx] && tag[idx].length > lengthMaxTag;
    const tagElem = (
      <Tag
        closeIcon={<CloseCircleOutlined />}
        className="tag"
        closable
        onClose={(e) => {
          e.preventDefault();
          handleCloseTag(tag[idx]);
        }}>
        <span>{isLongTag ? `${tag[idx].slice(0, lengthMaxTag)}...` : tag[idx]}</span>
      </Tag>
    );
    return isLongTag ? (
      <Tooltip title={tag[idx]} key={idx}>
        {tag?.length !== 0 ? tagElem : ''}
      </Tooltip>
    ) : (
      <span>{tag?.length !== 0 ? tagElem : ''}</span>
    );
  };

  // Método que muestra el tag para los tipos de beneficiado Generico y Conjunto
  const forTipoAsociacionGenericoConjunto = (tag, idx) => {
    const isLongTag = tag[idx] !== undefined ? tag[idx].length > lengthMaxTag : false;
    const tagElem = (
      <Tag
        closeIcon={<CloseCircleOutlined />}
        className="tag"
        closable
        onClose={(e) => {
          e.preventDefault();
          handleCloseTagGenericoConjunto(idx);
        }}>
        <span>{isLongTag ? `${tag[idx].slice(0, lengthMaxTag)}...` : tag[idx]}</span>
      </Tag>
    );
    return isLongTag ? (
      <Tooltip title={tag[idx]} key={idx}>
        {tag?.length !== 0 ? tagElem : ''}
      </Tooltip>
    ) : (
      <span>{tag?.length !== 0 ? tagElem : ''}</span>
    );
  };

  // Tipo de asociación al seleccionar beneficiado registrado
  const forBenTipoAso = (infoBen, idx) => {
    const isLongTag =
      infoBen[idx]?.tipoAsociacion !== undefined
        ? infoBen[idx].tipoAsociacion.length > lengthMaxTag
        : false;
    let infoBeneficiadoElem;
    if (isLongTag) {
      infoBeneficiadoElem = (
        <Tag className="tag">
          <span>
            {infoBen[idx]?.tipoAsociacion !== undefined
              ? `${infoBen[idx].tipoAsociacion.slice(0, lengthMaxTag)}...`
              : ''}
          </span>
        </Tag>
      );
    } else {
      infoBeneficiadoElem = (
        <Tag className="tag">
          <span>
            {infoBen[idx]?.tipoAsociacion !== undefined ? infoBen[idx].tipoAsociacion : ''}
          </span>
        </Tag>
      );
    }
    return isLongTag ? (
      <Tooltip
        title={infoBen[idx]?.tipoAsociacion !== undefined ? infoBen[idx].tipoAsociacion : ''}
        key={idx}>
        {infoBen[idx]?.tipoAsociacion !== undefined ? infoBeneficiadoElem : ''}
      </Tooltip>
    ) : (
      <span>{infoBen[idx]?.tipoAsociacion !== undefined ? infoBeneficiadoElem : ''}</span>
    );
  };

  // Tipo de asociación seleccionada mediante un select cuando el beneficiado no esta registrado en la base
  const forBenTipoAsoManual = (infoBen, idx) => {
    const selectInfoBeneficiadoElem = (
      <Select
        key={idx}
        className="select-tipo-so"
        options={listTipoAsociacion.map((tipoAsociacion) => ({
          label: tipoAsociacion.tipoAsociacion,
          value: tipoAsociacion.idTipoAsociacion
        }))}
        placeholder="Selecciona"
        onChange={(value, label) => getSujetosObligados(value, label, infoBen[idx])}
      />
    );
    return infoBen[idx]?.tipoAsociacion !== undefined ? selectInfoBeneficiadoElem : '';
  };

  // Sujeto obligado cuando el beneficiado esta registrado en la base de datos
  const forBenSO = (infoBen, idx) => {
    let infoBeneficiadoElem;
    const isLongTag =
      infoBen[idx]?.sujetoObligado !== undefined
        ? infoBen[idx].sujetoObligado.length > lengthMaxTag
        : false;
    if (infoBen[idx]?.idContabilidad === 0 && infoBen[idx]?.sujetoObligado !== '') {
      infoBeneficiadoElem = (
        <Tag
          closeIcon={<CloseCircleOutlined />}
          className="tag"
          closable
          onClose={(e) => {
            e.preventDefault();
            handleCloseTagSujetoObligado(infoBen[idx]);
          }}>
          <span>
            {isLongTag
              ? `${infoBen[idx].sujetoObligado.slice(0, lengthMaxTag)}...`
              : infoBen[idx].sujetoObligado}
          </span>
        </Tag>
      );
    } else {
      infoBeneficiadoElem = (
        <Tag className="tag">
          <span>
            {
              // eslint-disable-next-line no-nested-ternary
              isLongTag && infoBen[idx]?.sujetoObligado !== undefined
                ? `${infoBen[idx].sujetoObligado.slice(0, lengthMaxTag)}...`
                : infoBen[idx]?.sujetoObligado !== undefined
                ? infoBen[idx].sujetoObligado
                : ''
            }
          </span>
        </Tag>
      );
    }
    return isLongTag ? (
      <Tooltip
        title={infoBen[idx]?.sujetoObligado !== undefined ? infoBen[idx]?.sujetoObligado : ''}
        key={idx}>
        {infoBen[idx]?.sujetoObligado !== undefined ? infoBeneficiadoElem : ''}
      </Tooltip>
    ) : (
      <span key={idx}>{infoBen[idx]?.sujetoObligado !== undefined ? infoBeneficiadoElem : ''}</span>
    );
  };

  // Sujeto obligado manual o mediante selección precargada para sujeto obligado
  // en beneficiado Genérico o Conjunto
  const forBenSOGenericoConjunto = (infoBen, idx) => {
    let infoBeneficiadoElem;
    const isLongTag =
      infoBen[idx]?.sujetoObligado !== undefined
        ? infoBen[idx].sujetoObligado.length > lengthMaxTag
        : false;
    if (infoBen[idx]?.sujetoObligado !== undefined && infoBen[idx]?.sujetoObligado !== '') {
      infoBeneficiadoElem = (
        <Tag
          key={idx}
          closeIcon={<CloseCircleOutlined />}
          className="tag"
          closable
          onClose={(e) => {
            e.preventDefault();
            handleCloseTagSujetoObligadoGenericoConjunto(infoBen[idx], idx);
          }}>
          {isLongTag
            ? `${infoBen[idx].sujetoObligado.slice(0, lengthMaxTag)}...`
            : infoBen[idx].sujetoObligado}
        </Tag>
      );
    } else {
      infoBeneficiadoElem = (
        <Tag className="tag" key={idx}>
          {
            // eslint-disable-next-line no-nested-ternary
            isLongTag && infoBen[idx]?.sujetoObligado !== undefined
              ? `${infoBen[idx].sujetoObligado.slice(0, lengthMaxTag)}...`
              : infoBen[idx]?.sujetoObligado !== undefined
              ? infoBen[idx].sujetoObligado
              : ''
          }
        </Tag>
      );
    }
    return isLongTag ? (
      <Tooltip
        title={infoBen[idx]?.sujetoObligado !== undefined ? infoBen[idx]?.sujetoObligado : ''}
        key={idx}>
        {infoBen[idx]?.sujetoObligado !== undefined ? infoBeneficiadoElem : ''}
      </Tooltip>
    ) : (
      <span key={idx}>{infoBen[idx]?.sujetoObligado !== undefined ? infoBeneficiadoElem : ''}</span>
    );
  };

  // Sujeto obligado manual cuando el beneficiado no esta registrado en la base de datos
  const forSujetoObligadoManual = (infoBen, idx) => {
    const tagInputSujetoObligado =
      infoBen[idx].flag === 'so' ? (
        <AutoComplete
          key={idx}
          className="autocomplete"
          options={listSujetosObligados}
          // eslint-disable-next-line no-shadow
          filterOption={(inputValue, option) =>
            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          }
          onSelect={(v, option) =>
            handleInputSelectConfirmSujetoObligadoBeneficiado(v, option, infoBen[idx])
          }>
          <Input
            key={idx}
            className="input-autocomplete"
            ref={inputRefSO}
            type="text"
            onBlur={(e) => handleInputConfirmSujetoObligadoBeneficiado(e, infoBen[idx])}
            onPressEnter={(e) => handleInputConfirmSujetoObligadoBeneficiado(e, infoBen[idx])}
          />
        </AutoComplete>
      ) : (
        <Tag
          className="add-tag"
          onClick={() => showInputSujetoObligado(infoBen[idx])}
          style={{ background: token.colorBgContainer }}>
          <PlusOutlined />
          <span>Agregar sujeto obligado</span>
        </Tag>
      );
    return (
      <span key={idx} className="tag-container">
        {tagInputSujetoObligado}
      </span>
    );
  };

  // Sujeto Obligado de forma manual y con lista de opciones para
  // beneficiados genericos y conjunto
  const forSujetoObligadoManualGenericoConjunto = (infoBen, idx) => {
    const tagInputSujetoObligado =
      infoBen[idx].flag === 'so' ? (
        <AutoComplete
          key={idx}
          className="autocomplete"
          options={listSujetosObligados}
          // eslint-disable-next-line no-shadow
          filterOption={(inputValue, option) =>
            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          }
          onSelect={(v, option) =>
            handleInputSelectConfirmSujetoObligadoBeneficiadoGenericoConjunto(
              v,
              option,
              infoBen[idx],
              idx
            )
          }>
          <Input
            key={idx}
            className="input-autocomplete"
            ref={inputRefSO}
            type="text"
            onBlur={(e) =>
              handleInputConfirmSujetoObligadoBeneficiadoGenericoConjunto(e, infoBen[idx], idx)
            }
            onPressEnter={(e) =>
              handleInputConfirmSujetoObligadoBeneficiadoGenericoConjunto(e, infoBen[idx], idx)
            }
          />
        </AutoComplete>
      ) : (
        <Tag
          className="add-tag"
          onClick={() => showInputSujetoObligadoGenericoConjunto(infoBen[idx], idx)}
          style={{ background: token.colorBgContainer }}>
          <PlusOutlined />
          <span>Agregar sujeto obligado</span>
        </Tag>
      );
    return (
      <span key={idx} className="tag-container">
        {tagInputSujetoObligado}
      </span>
    );
  };

  // Se ingresa el cargo mediante un tag cuando el beneficiado esta
  // registrado en la base de datos
  const forBenCargo = (infoBen, idx) => {
    let infoBeneficiadoElem;
    const isLongTag =
      infoBen[idx]?.cargo !== undefined ? infoBen[idx]?.cargo?.length > lengthMaxTag : false;
    if (infoBen[idx]?.idContabilidad === 0 && infoBen[idx]?.cargo !== '') {
      infoBeneficiadoElem = (
        <Tag
          closeIcon={<CloseCircleOutlined />}
          className="tag"
          closable
          onClose={(e) => {
            e.preventDefault();
            handleCloseTagCargo(infoBen[idx], idx);
          }}>
          <span>
            {isLongTag
              ? `${infoBen[idx]?.cargo?.slice(0, lengthMaxTag).toUpperCase()}...`
              : infoBen[idx]?.cargo?.toUpperCase()}
          </span>
        </Tag>
      );
    } else {
      infoBeneficiadoElem = (
        <Tag className="tag">
          <span>
            {
              // eslint-disable-next-line no-nested-ternary
              isLongTag && infoBen[idx]?.cargo !== undefined
                ? `${infoBen[idx].cargo.slice(0, lengthMaxTag).toUpperCase()}...`
                : infoBen[idx]?.cargo !== undefined
                ? infoBen[idx].cargo.toUpperCase()
                : ''
            }
          </span>
        </Tag>
      );
    }
    return isLongTag ? (
      <Tooltip title={infoBen[idx]?.cargo !== undefined ? infoBen[idx]?.cargo : ''} key={idx}>
        {infoBen[idx]?.cargo !== undefined ? infoBeneficiadoElem : ''}
      </Tooltip>
    ) : (
      <span key={idx}>{infoBen[idx]?.cargo !== undefined ? infoBeneficiadoElem : ''}</span>
    );
  };

  // Se ingresa el cargo mediante un tag cuando el beneficiado esta
  // registrado en la base de datos
  const forBenCargoGenericoConjunto = (infoBen, idx) => {
    let infoBeneficiadoElem;
    const isLongTag =
      infoBen[idx]?.cargo !== undefined ? infoBen[idx].cargo.length > lengthMaxTag : false;
    if (infoBen[idx]?.cargo !== '') {
      infoBeneficiadoElem = (
        <Tag
          closeIcon={<CloseCircleOutlined />}
          className="tag"
          closable
          onClose={(e) => {
            e.preventDefault();
            handleCloseTagCargo(infoBen[idx], idx);
          }}>
          <span>
            {
              // eslint-disable-next-line no-nested-ternary
              isLongTag && infoBen[idx]?.cargo !== undefined
                ? `${infoBen[idx].cargo.slice(0, lengthMaxTag).toUpperCase()}...`
                : infoBen[idx]?.cargo !== undefined
                ? infoBen[idx].cargo.toUpperCase()
                : ''
            }
          </span>
        </Tag>
      );
    }
    return isLongTag ? (
      <Tooltip title={infoBen[idx]?.cargo !== undefined ? infoBen[idx]?.cargo : ''} key={idx}>
        {infoBen[idx]?.cargo !== undefined ? infoBeneficiadoElem : ''}
      </Tooltip>
    ) : (
      <span key={idx}>{infoBen[idx]?.cargo !== undefined ? infoBeneficiadoElem : ''}</span>
    );
  };

  // Se ingresa el cargo de forma manual cuando el usuario no esta registrado en base de datos
  const forBenCargoManual = (infoBen, idx) => {
    const tagInputCargo =
      infoBen[idx].flag === 'car' ? (
        <AutoComplete
          key={idx}
          className="autocomplete"
          options={listCargos}
          // eslint-disable-next-line no-shadow
          filterOption={(inputValue, option) =>
            option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
          }
          onSelect={(e) => handleInputSelectConfirmCargoBeneficiado(e, infoBen[idx], idx)}>
          <Input
            key={idx}
            className="input-autocomplete"
            ref={inputRef}
            type="text"
            onBlur={(e) => handleInputConfirmCargoBeneficiado(e, infoBen[idx], idx)}
            onPressEnter={(e) => handleInputConfirmCargoBeneficiado(e, infoBen[idx], idx)}
          />
        </AutoComplete>
      ) : (
        <Tag
          className="add-tag"
          onClick={() => showInputCargo(infoBen[idx], idx)}
          style={{ background: token.colorBgContainer }}>
          <PlusOutlined />
          <span>Agregar cargo</span>
        </Tag>
      );
    return (
      <span key={idx} className="tag-container">
        {tagInputCargo}
      </span>
    );
  };

  // Id de contabilidad se ingresa un cero cuando el beneficiado no esta registrado en la base de datos
  const forBenIdConta = (infoBen, idx) => {
    const infoBeneficiadoElem = (
      <Tag className="tag-element-beneficio-directo">
        <Text>{infoBen[idx]?.idContabilidad !== undefined ? infoBen[idx].idContabilidad : ''}</Text>
      </Tag>
    );
    return (
      <span key={idx} className="tag-container">
        {infoBeneficiadoElem}
      </span>
    );
  };

  // Hook que habilita el input reference en el tag correspondiente para ingresar
  // el cargo, sujeto obligado o el nombre del beneficiado
  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus();
    }
    if (inputSujetoObligadoVisible) {
      inputRefSO.current?.focus();
    }
    if (inputCargoVisible) {
      inputRef.current?.focus();
    }
    if (inputSujetoObligadoGenConjVisible) {
      inputRefSOGC.current?.focus();
    }
  }, [
    inputVisible,
    inputSujetoObligadoVisible,
    inputCargoVisible,
    inputSujetoObligadoGenConjVisible
  ]);

  const handleChange = (v) => {
    setLoading(true);
    setTags([]);
    setInfoBeneficiados([]);
    setListaBeneficiados([]);
    setListTipoAsociacion([]);
    form.setFieldsValue({ beneficiados: [] });
    form.resetFields(['beneficiados']);
    setTipoBeneficioSeleccionado(v);
    loadBeneficiados();
    // getTiposAsociacion();
    setLoading(false);
  };

  // Hook para cargar la lista de beneficiados
  useEffect(() => {
    if (
      beneficiadosList !== null &&
      beneficiadosList !== undefined &&
      beneficiadosList.length > 0
    ) {
      setListaBeneficiados(beneficiadosList);
    }
  }, []);

  // Hook para cargar el tipo de beneficiado inicial
  useEffect(() => {
    setTipoBeneficioSeleccionado(tipoBeneficioInicial);
  }, [tipoBeneficioInicial]);

  // Hook para forzar el renderizado cuando el tipo de beneficio inicial no cambia
  useEffect(() => {
    setRenderBeneficiadosEdit(renderBeneficiados);
  }, [renderBeneficiados]);

  // Hook para cargar los beneficiados cuando se edita el monitoreo
  useEffect(() => {
    if (
      (tipoBeneficioSelecionado === 2 && actionType) ||
      (tipoBeneficioSelecionado === 3 && actionType)
    ) {
      handleTagInBeneficiados();
    }

    if (
      (tipoBeneficioSelecionado === 1 && actionType) ||
      (tipoBeneficioSelecionado === 4 && actionType)
    ) {
      handleTagInBeneficiadosGenericosConjunto();
    }
    loadBeneficiados();
    getTiposAsociacion();
    getCargos();
  }, [tipoBeneficioSelecionado, renderBeneficiadosEdit]);

  useEffect(() => {
    getTiposAsociacion();
  }, [listaBeneficiados]);

  const renderHeaders = (tipoBeneficio) => {
    if (tipoBeneficio === DIRECTO || tipoBeneficio === PERSONALIZADO)
      return (
        <Row gutter={24}>
          <Col xs={5} className="beneficiados-header-tabla">
            <span>*</span>Beneficiados
          </Col>
          <Col xs={5} className="beneficiados-header-tabla">
            <span>*</span>Tipo de asociación:
          </Col>
          <Col xs={5} className="beneficiados-header-tabla">
            <span>*</span>Sujeto Obligado:
          </Col>
          <Col xs={5} className="beneficiados-header-tabla">
            <span>*</span>Cargo:
          </Col>
          <Col xs={3} className="beneficiados-header-tabla">
            <span>*</span>ID de contabilidad:
          </Col>
        </Row>
      );
    if (tipoBeneficio === GENERICO)
      return (
        <Row gutter={24}>
          <Col xs={7} className="beneficiados-header-tabla">
            <span>*</span>Tipo de asociación:
          </Col>
          <Col xs={7} className="beneficiados-header-tabla">
            <span>*</span>Sujeto Obligado:
          </Col>
        </Row>
      );
    if (tipoBeneficio === CONJUNTO)
      return (
        <Row gutter={24}>
          <Col xs={6} className="beneficiados-header-tabla">
            <span>*</span>Tipo de asociación:
          </Col>
          <Col xs={6} className="beneficiados-header-tabla">
            <span>*</span>Sujeto Obligado:
          </Col>
          <Col xs={6} className="beneficiados-header-tabla">
            <span>*</span>Cargo:
          </Col>
        </Row>
      );
    return null;
  };

  const renderInput = (tipoBeneficio, field, index) => {
    if (tipoBeneficio === DIRECTO) {
      return (
        <Row gutter={24} className="beneficiario-input-formulario" key={index}>
          <Col xs={5}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) => {
                return prevValues.idProcesoEspecifico !== curValues.idProcesoEspecifico;
              }}>
              {() => {
                // const { idProcesoEspecifico } = form.getFieldsValue(['idProcesoEspecifico']);
                // const { idEstado } = form.getFieldsValue(['idEstado']);
                // const beneficiadosPorProcesoEspecifico = listaBeneficiados.filter(
                //   (beneficiado) =>
                //     beneficiado.idProcesoSIMAC === idProcesoEspecifico &&
                //     beneficiado.idEstado === idEstado
                // );
                const beneficiadosPorProcesoEspecifico = listaBeneficiados;
                // const beneficiadosNuevo = beneficiadosPorProcesoEspecifico?.map((beneficiado) =>
                //   // const beneficiadosNuevo = listaBeneficiados.map((beneficiado) =>
                //   Object.defineProperty(
                //     beneficiado,
                //     'value',
                //     Object.getOwnPropertyDescriptor(beneficiado, 'nombreBeneficiado')
                //   )
                // );
                const beneficiadosNuevo = beneficiadosPorProcesoEspecifico?.map((beneficiado) => ({
                  ...beneficiado,
                  // value: `${beneficiado.nombreBeneficiado} ${beneficiado.idContabilidad}`
                  value: `${beneficiado.idContabilidad}`,
                  label: `${beneficiado.nombreBeneficiado}`
                }));
                return (
                  <Form.Item
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    name={[field.name, 'nombreBeneficiado']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.nombreBeneficiado === undefined
                      ? inputAutocompleteBeneficiadoDirecto(
                          beneficiadosNuevo,
                          beneficiadosPorProcesoEspecifico,
                          index
                        )
                      : forNomBeneficiadoDirecto(tags, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          {/* shouldUpdate Se agrega para que el contenido interno siempre se vuelva a renderizar
            si cambia el valor del tag, el formulario esta optiomizado para que solo se renderice
            el input que cambie
          */}
          <Col xs={5}>
            <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues !== curValues}>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'tipoAsociacion']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.idBeneficiado === 0
                      ? forBenTipoAsoManual(infoBeneficiados, index)
                      : forBenTipoAso(infoBeneficiados, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={5}>
            <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues !== curValues}>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'sujetoObligado']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.idContabilidad === 0 &&
                    infoBeneficiados[index]?.sujetoObligado === ''
                      ? forSujetoObligadoManual(infoBeneficiados, index)
                      : forBenSO(infoBeneficiados, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={5}>
            <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues !== curValues}>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'cargo']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.idContabilidad === 0 &&
                    infoBeneficiados[index].cargo === ''
                      ? forBenCargoManual(infoBeneficiados, index)
                      : forBenCargo(infoBeneficiados, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={3}>
            <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues !== curValues}>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'idContabilidad']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.idContabilidad !== undefined
                      ? forBenIdConta(infoBeneficiados, index)
                      : ''}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
        </Row>
      );
    }
    if (tipoBeneficio === PERSONALIZADO) {
      return (
        <Row gutter={24} className="beneficiario-input-formulario" key={index}>
          <Col xs={5}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) => {
                return (
                  prevValues.idProcesoEspecifico !== curValues.idProcesoEspecifico ||
                  prevValues.idEstado !== curValues.idEstado
                );
              }}>
              {() => {
                // const { idProcesoEspecifico } = form.getFieldsValue(['idProcesoEspecifico']);
                // const { idEstado } = form.getFieldsValue(['idEstado']);
                // const beneficiadosPorProcesoEspecifico = listaBeneficiados?.filter(
                //   (beneficiado) =>
                //     beneficiado.idProcesoSIMAC === idProcesoEspecifico &&
                //     beneficiado.idEstado === idEstado
                // );
                const beneficiadosPorProcesoEspecifico = listaBeneficiados;
                // console.log('listaBeneficiados: ', listaBeneficiados);
                // const beneficiadosNuevo =
                //   beneficiadosPorProcesoEspecifico?.map((beneficiado) =>
                //     Object.defineProperty(
                //       beneficiado,
                //       'value',
                //       `${Object.getOwnPropertyDescriptor(
                //         beneficiado,
                //         'nombreBeneficiado'
                //       )} ${Object.getOwnPropertyDescriptor(beneficiado, 'idContabilidad')}`
                //     )
                //   ) || [];

                // Convertimos infoBeneficiados a un Set para evitar duplicados
                const infoBeneficiadosIds = new Set(infoBeneficiados.map((b) => b.idContabilidad));

                // Eliminamos duplicados en beneficiadosNuevo antes de mapearlos
                const beneficiadosUnicos = new Map();
                beneficiadosPorProcesoEspecifico?.forEach((beneficiado) => {
                  if (!beneficiadosUnicos.has(beneficiado.idContabilidad)) {
                    beneficiadosUnicos.set(beneficiado.idContabilidad, {
                      ...beneficiado,
                      value: `${beneficiado.idContabilidad}`,
                      label: `${beneficiado.nombreBeneficiado}`
                    });
                  }
                });

                // Convertimos el Map en un Array
                const beneficiadosNuevo = Array.from(beneficiadosUnicos.values());

                // Filtramos eliminando aquellos que ya existen en infoBeneficiados
                const nuevaListaBeneficiados = beneficiadosNuevo.filter(
                  (beneficiado) =>
                    beneficiado.idContabilidad > 0 &&
                    !infoBeneficiadosIds.has(beneficiado.idContabilidad)
                );

                return (
                  <Form.Item
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    name={[field.name, 'nombreBeneficiado']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.nombreBeneficiado === undefined
                      ? inputAutocompleteBeneficiadoPersonalizado(
                          nuevaListaBeneficiados,
                          beneficiadosPorProcesoEspecifico,
                          index
                        )
                      : forNomBeneficiadoPersonalizado(tags, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          {/* shouldUpdate Se agreg par que el contenido interno siempre se vuelva a renderizar
            si cambia el valor del tag pues el formulario esta optiomizado para que solo se renderice
            el input que cambie
          */}
          <Col xs={5}>
            <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues !== curValues}>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'tipoAsociacion']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.idBeneficiado === 0
                      ? forBenTipoAsoManual(infoBeneficiados, index)
                      : forBenTipoAso(infoBeneficiados, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={5}>
            <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues !== curValues}>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'sujetoObligado']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.idContabilidad === 0 &&
                    infoBeneficiados[index]?.sujetoObligado === ''
                      ? forSujetoObligadoManual(infoBeneficiados, index)
                      : forBenSO(infoBeneficiados, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={5}>
            <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues !== curValues}>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'cargo']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.idContabilidad === 0 &&
                    infoBeneficiados[index].cargo === ''
                      ? forBenCargoManual(infoBeneficiados, index)
                      : forBenCargo(infoBeneficiados, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={3}>
            <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues !== curValues}>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'idContabilidad']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.idContabilidad !== undefined
                      ? forBenIdConta(infoBeneficiados, index)
                      : ''}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
        </Row>
      );
    }
    if (tipoBeneficio === GENERICO) {
      return (
        <Row gutter={24} className="beneficiario-input-formulario" key={index}>
          <Col xs={7}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) => {
                return prevValues.idProcesoEspecifico !== curValues.idProcesoEspecifico;
              }}>
              {() => {
                const { idProcesoEspecifico } = form.getFieldsValue(['idProcesoEspecifico']);
                const tiposAsociacionPorProcesoEspecifico = getTiposAsociacionPorProcesoEspecifico(
                  listaBeneficiados,
                  idProcesoEspecifico
                );
                return (
                  <Form.Item
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    name={[field.name, 'tipoAsociacion']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados?.length === 0
                      ? selectBenGenericoConjunto(tiposAsociacionPorProcesoEspecifico, index)
                      : forTipoAsociacionGenericoConjunto(tags, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={7}>
            {/* shouldUpdate Se agreg par que el contenido interno siempre se vuelva a renderizar
            si cambia el valor del select pues el formulario esta optiomizado para que solo se renderice
            el input que cambie
          */}
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) =>
                prevValues.beneficiados !== curValues.beneficiados
              }>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'sujetoObligado']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.sujetoObligado === ''
                      ? forSujetoObligadoManualGenericoConjunto(infoBeneficiados, index)
                      : forBenSOGenericoConjunto(infoBeneficiados, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
        </Row>
      );
    }
    if (tipoBeneficio === CONJUNTO) {
      return (
        <Row gutter={24} className="beneficiario-input-formulario" key={index}>
          <Col xs={6}>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) => {
                return prevValues.idProcesoEspecifico !== curValues.idProcesoEspecifico;
              }}>
              {() => {
                const { idProcesoEspecifico } = form.getFieldsValue(['idProcesoEspecifico']);
                const tiposAsociacionPorProcesoEspecifico = getTiposAsociacionPorProcesoEspecifico(
                  listaBeneficiados,
                  idProcesoEspecifico
                );
                return (
                  <Form.Item
                    // eslint-disable-next-line react/jsx-props-no-spreading
                    {...field}
                    name={[field.name, 'tipoAsociacion']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.tipoAsociacion === undefined
                      ? selectBenGenericoConjunto(tiposAsociacionPorProcesoEspecifico, index)
                      : forTipoAsociacionGenericoConjunto(tags, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={6}>
            {/* shouldUpdate Se agreg par que el contenido interno siempre se vuelva a renderizar
            si cambia el valor del select pues el formulario esta optiomizado para que solo se renderice
            el input que cambie
          */}
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) =>
                prevValues.beneficiados !== curValues.beneficiados
              }>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'sujetoObligado']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.sujetoObligado === ''
                      ? forSujetoObligadoManualGenericoConjunto(infoBeneficiados, index)
                      : forBenSOGenericoConjunto(infoBeneficiados, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
          <Col xs={6}>
            {/* shouldUpdate Se agreg par que el contenido interno siempre se vuelva a renderizar
            si cambia el valor del select pues el formulario esta optiomizado para que solo se renderice
            el input que cambie
          */}
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) =>
                prevValues.beneficiados !== curValues.beneficiados
              }>
              {() => {
                return (
                  <Form.Item
                    name={[field.name, 'cargo']}
                    rules={[
                      {
                        required: true,
                        message: fieldMsgs.ERR_TEXT_FIELD_REQUIRED
                      }
                    ]}>
                    {infoBeneficiados[index]?.cargo === ''
                      ? forBenCargoManual(infoBeneficiados, index)
                      : forBenCargoGenericoConjunto(infoBeneficiados, index)}
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
        </Row>
      );
    }
    return null;
  };

  return (
    <div className="formulario-beneficiados">
      <Spin spinning={loading}>
        <Form form={form} layout="vertical">
          <Form.Item
            name="tipo_beneficio"
            label="Tipo de beneficio"
            rules={[
              {
                required: true,
                message: fieldMsgs.ERR_SELECT_FIELD_REQUIRED
              }
            ]}>
            <Select
              placeholder="Selecciona"
              options={tipoBeneficios.map((beneficio) => ({
                label: beneficio.nombreTipoBeneficio,
                value: beneficio.idTipoBeneficio
              }))}
              onChange={handleChange}
              style={{ width: '20em' }}
            />
          </Form.Item>
          {renderHeaders(tipoBeneficioSelecionado)}
          <Form.List name="beneficiados" initialValue={[]}>
            {(fields, { add }) => (
              <>
                {fields.map((field, index) => {
                  const tipoBeneficio = form.getFieldValue('tipo_beneficio');
                  if (!tipoBeneficio) return null;
                  return renderInput(tipoBeneficioSelecionado, field, index);
                })}
                <Divider />
                <Form.Item>
                  {(tipoBeneficioSelecionado === 3 ||
                    tipoBeneficioSelecionado === 4 ||
                    form.getFieldValue('beneficiados').length === 0) && (
                    <AddButton onClick={() => add()}>Agregar Nuevo</AddButton>
                  )}
                </Form.Item>
              </>
            )}
          </Form.List>
        </Form>
      </Spin>
    </div>
  );
};

Beneficiados.propTypes = {
  form: PropTypes.shape({
    setFieldsValue: PropTypes.func,
    resetFields: PropTypes.func,
    getFieldValue: PropTypes.func,
    getFieldInstance: PropTypes.func,
    getFieldsValue: PropTypes.func
  }).isRequired,
  tipoBeneficioInicial: PropTypes.number,
  isLoading: PropTypes.bool,
  renderBeneficiados: PropTypes.number,
  actionType: PropTypes.bool
};

Beneficiados.defaultProps = {
  tipoBeneficioInicial: null,
  isLoading: null,
  renderBeneficiados: null,
  actionType: false
};

export default Beneficiados;
